import React, { useState } from "react";
import Layout from "../layout/Layout";
import Banner from "../components/pricing/Banner";
import Plans from "../components/pricing/Plans";
import Faq from "../components/pricing/Faq";
import Cta from "../components/cta/cta";

const PricingPlan = () => {
  return (
    <>
      <Layout>
        {/* <Banner /> */}
        <Plans />
        <Cta
          heading="Ready to supercharge your lead generation?"
          firstCta="/signup"
          firstCtaText="Start Free Trial"
          secondCta="/contact-us"
          secondCtaText="Schedule a Demo"
        />
        <Faq />
      </Layout>
    </>
  );
};

export default PricingPlan;
